<template>
  <b-modal
    id="modal-success-confirm-email"
    hide-footer
    centered
    :noCloseOnBackdrop="loading"
    :noCloseOnEsc="loading"
    :hideHeaderClose="loading"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <img
        class="centerImg1 mb-4"
        src="@/assets/images/icons/icon-morbidity/icon9.png"
      />
      <h3><strong>¡Correo electronico enviado!</strong></h3>
      <p>
        Por favor revisa tu bandeja de entrada.
      </p>

      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button-primary"
          style="color: white !important"
          :disabled="loading"
          @click.prevent="$bvModal.hide('modal-success-confirm-email')"
        >
          Ok
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
